import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { Observable } from 'rxjs'
@Injectable({
	providedIn: 'root',
})
export class CreateCategoryService {
	constructor(private http: HttpClient) {}
	private env = environment

	public postInfoCategory(data: any): Observable<any> {
		data['partnerId'] = '595166383625c506d4868f28'
		data['type'] = 'creditCard'
		return this.http.post(`${this.env.channelsAPI.baseURL}categories`, data)
	}

	public getInfoCategory(idCategory: any): Observable<any> {
		return this.http.get(`${this.env.channelsAPI.baseURL}categories/${idCategory}`)
	}

	public getBenefitsList(): Observable<any> {
		return this.http.get(`${this.env.channelsAPI.baseURL}benefits`)
	}

	public removeCategory(idCategory: any): Observable<any> {
		return this.http.delete(`${this.env.channelsAPI.baseURL}categories/${idCategory}`)
	}

	public editCategory(idCategory: any, data: any): Observable<any> {
		return this.http.patch(`${this.env.channelsAPI.baseURL}categories/${idCategory}`, data)
	}
}
